import SupplierPurchaseProposalForm from '../../../components/purchase-fuel/suppliers-proposal/SuppliersProposalForm'
import createAsyncThunkMiddleware from '../../../utils/helpers/createAsyncThunkMiddleware'
import {
  DELETE,
  GET,
  PATCH,
  POST,
  POST_FILE,
} from '../../common/common.service'
import endpointsProposal from './endpoints'

export const SuppliersProposalService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsProposal.LOAD(filter, sort, limit, skip)),
  getLast: async (province) => GET(endpointsProposal.LAST(province)),
  create: async (body) => POST(endpointsProposal.CREATE, body),
  getById: async (id) => GET(endpointsProposal.BY_ID(id)),
  update: async ({ _id, body }) =>
    PATCH(endpointsProposal.BY_ID(_id), body, false),
  updateByIdAndProvinceId: async ({ _id, body }) =>
    PATCH(endpointsProposal.BY_ID_AND_PROVINCEID(_id, body._id), body, false),
  updateSelectedProvinceSupplier: async ({ _id, body }) =>
    PATCH(
      endpointsProposal.UPDATE_SELECTED_PROVINCE_SUPPLIER(_id),
      body,
      false,
    ),
  remove: async (id) => DELETE(endpointsProposal.BY_ID(id)),
  uploadExcel: async (file) => POST_FILE(endpointsProposal.UPLOAD, file),
}

export const uploadExcelFile = createAsyncThunkMiddleware(
  'purchases/proposal/upload',
  SuppliersProposalService.uploadExcel,
)
